var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconAddToBatch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.595,
    height: 17.595,
    viewBox: "0 0 17.595 17.595",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-import-708427",
    d: "M126,72.5a1.1,1.1,0,0,0,1.1,1.1H142.49a1.1,1.1,0,0,0,1.1-1.1v-7.7a1.1,1.1,0,1,0-2.2.006V71.4H128.2V64.8a1.1,1.1,0,1,0-2.2-.006Zm8.8-16.5a1.094,1.094,0,0,0-1.1,1.1V63.7h-2.2c-.607,0-.753.345-.322.776l3.622,3.622,3.622-3.622c.429-.429.29-.776-.322-.776h-2.2V57.1A1.1,1.1,0,0,0,134.794,56Z",
    transform: "translate(-125.996 -56)",
    fill: "#ff7113",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAddToBatch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-add-to-batch.aa147818.svg";
export { ForwardRef as ReactComponent };